import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
    Box // <-- add this
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";

export default function AddCategory() {
  const [open, setOpen] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  const [categories, setCategories] = useState([]);
  const [editId, setEditId] = useState(null); // Track edit mode

  const fetchCategories = async () => {
    try {
      const res = await axios.get("https://reviewhub-lc.onrender.com/api/categories");
      setCategories(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleClickOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setCategoryName("");
    setImage(null);
    setPreview("");
    setEditId(null);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSave = async () => {
    if (!categoryName) {
      alert("Please enter category name");
      return;
    }

    const formData = new FormData();
    formData.append("categoryName", categoryName);
    if (image) formData.append("image", image);

    try {
      if (editId) {
        await axios.put(`https://reviewhub-lc.onrender.com/api/categories/${editId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        alert("Category updated successfully!");
      } else {
        await axios.post("https://reviewhub-lc.onrender.com/api/categories", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        alert("Category added successfully!");
      }
      handleClose();
      fetchCategories();
    } catch (err) {
      console.error(err);
      alert("Error saving category");
    }
  };

  const handleEdit = (cat) => {
    setCategoryName(cat.categoryName);
    setPreview(`https://reviewhub-lc.onrender.com/uploads/${cat.image}`);
    setEditId(cat._id);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await axios.delete(`https://reviewhub-lc.onrender.com/api/categories/${id}`);
        alert("Category deleted successfully!");
        fetchCategories();
      } catch (err) {
        console.error(err);
        alert("Error deleting category");
      }
    }
  };

  return (
    <div>
            <Typography variant="h4" gutterBottom fontWeight={600}>
        Manage Categories
            </Typography>
      {/* Add Category Button */}
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleClickOpen}
        sx={{ mb: 2 }}
      >
        Add Category
      </Button>

      {/* Categories Table */}
      <TableContainer component={Paper}>
               <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Image</TableCell>
              <TableCell>Category Name</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {categories.map((cat) => (
              <TableRow key={cat._id}>
                <TableCell>
                  <img
                    src={`https://reviewhub-lc.onrender.com/uploads/${cat.image}`}
                    alt={cat.categoryName}
                    style={{
                      width: 60,
                      height: 60,
                      objectFit: "cover",
                      borderRadius: 4,
                    }}
                  />
                </TableCell>
                <TableCell>{cat.categoryName}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleEdit(cat)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => handleDelete(cat._id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </div>
      </TableContainer>

      {/* Dialog for Adding / Editing Category */}
   <Dialog
  open={open}
  onClose={handleClose}
  maxWidth="sm"
  fullWidth
  PaperProps={{
    sx: {
      width: 400, // fixed width
      height: 450, // fixed height
    },
  }}
>
  <DialogTitle>
    {editId ? "Edit Category" : "Add New Category"}
  </DialogTitle>
  <DialogContent>
    <Stack spacing={2} sx={{ mt: 1 }}>
      <TextField
        label="Category Name"
        fullWidth
        value={categoryName}
        onChange={(e) => setCategoryName(e.target.value)}
      />

      <Button
        variant="outlined"
        component="label"
        startIcon={<CloudUploadIcon />}
      >
        Upload Image
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={handleImageChange}
        />
      </Button>

      {/* Fixed size preview area */}
      <Box
        sx={{
          width: "100%",
          height: 150,
          border: "1px dashed #ccc",
          borderRadius: "4px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f9f9f9",
          mt: 1,
          overflow: "hidden",
        }}
      >
        {preview ? (
          <img
            src={preview}
            alt="Category Preview"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        ) : (
          <Typography variant="body2" color="textSecondary">
            No Image Selected
          </Typography>
        )}
      </Box>
    </Stack>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleClose} color="secondary">
      Cancel
    </Button>
    <Button onClick={handleSave} variant="contained" color="primary">
      {editId ? "Update" : "Save"}
    </Button>
  </DialogActions>
</Dialog>

    </div>
  );
}
